import { Component, Input, input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { LanguageService } from '../services/languageservice/language.service';
import {
  AttendeeInformation,
  BookingPeriod,
  BookingTypeValue,
  DATETIMEFORMART,
  EventRequest,
  reminderMinutes,
  SearchRequest,
  showAsOptions,
} from '../interfaces/interfaces';
import { ModalController, Platform, ViewDidEnter } from '@ionic/angular';
import { ApiService } from '../services/api-services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, finalize, map, of, switchMap } from 'rxjs';
import { ToastService } from '../services/toast-service/toast.service';
import { DatetimeFormatService } from '../services/datetime-format-service/datetime-format.service';
import { LocalNotificationService } from '../services/localNotification/local-notification.service';
import { BackService } from '../services/back-service/back.service';
import { AuthService } from '../services/authService/auth.service';
import { PlacesService } from '../services/placesService/places.service';
import { UserStore } from '../stores/user.store';
import { PlacesStore } from '../stores/places.store';
import { AddAttendeeComponent } from '../shared/add-attendee/add-attendee.component';

@Component({
  selector: 'app-avaliable-time-booking',
  templateUrl: './avaliable-time-booking.page.html',
  styleUrls: ['./avaliable-time-booking.page.scss'],
})
export class AvaliableTimeBookingPage
  implements OnInit, ViewDidEnter, OnDestroy
{
  @Input() public place: any;
  public bookingType: string = 'scheduleBooking';
  public locale = this.dateTimeFormatService.selectedDateTimeFormat;
  public periods = [];
  public slidersLoading = true;
  public minimalDate: string;
  public subtitle: string = 'scheduleBookingSubtitle';
  public newDate = moment().format('YYYY-MM-DD');
  subject = null;
  reminutesToSelect = reminderMinutes;
  showAsOptions = showAsOptions;
  showAs = this.userStore.userPreferences()?.userSettings?.bookingStatus;
  reminderMinutesBeforeStart: number = 15;
  attendees: AttendeeInformation[] = [];
  isAutoGrow = false;
  isTimeSelected = false;
  searchRequest: SearchRequest;
  searchRequestDate;
  sliderNumber: number;
  vehicleNumber: string = this.userStore.user()?.vehicleNumber;
  canBookOnline: boolean = false;
  isOnlineMeeting: boolean = false;
  bookingLoading: boolean;
  errorMessage: string = '';
  showError: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private languageService: LanguageService,
    private translateService: TranslateService,
    public apiService: ApiService,
    private toastService: ToastService,
    private platform: Platform,
    private modalController: ModalController,
    private dateTimeFormatService: DatetimeFormatService,
    private localNotificationService: LocalNotificationService,
    private backService: BackService,
    public userStore: UserStore,
    private placesStore: PlacesStore
  ) {}

  ngOnInit() {
    this.InitComponentData();

    let end =
      this.newDate != moment().format('YYYY-MM-DD')
        ? moment(this.newDate)
            .set({ hours: 23, minutes: 59, seconds: 0 })
            .utc()
            .toISOString()
        : moment()
            .set({ hours: 23, minutes: 59, seconds: 0 })
            .utc()
            .toISOString();
    let start =
      this.newDate != moment().format('YYYY-MM-DD')
        ? moment(this.newDate)
            .set({ hours: 0, minutes: 0, seconds: 1 })
            .utc()
            .toISOString()
        : moment().set('milliseconds', 0).utc().toISOString();
    this.getAvailableTimesForSliders(start, end);
  }

  ngOnDestroy(): void {}

  ionViewDidEnter(): void {}

  private InitComponentData() {
    this.minimalDate = moment().format('YYYY-MM-DD');
    if (this.placesStore.searchRequest() == null) {
      this.searchRequestDate = this.minimalDate;
    } else {
      this.searchRequestDate = moment(
        this.placesStore.searchRequest().startTime
      ).format('YYYY-MM-DD');
      this.newDate = moment(this.placesStore.searchRequest().startTime).format(
        'YYYY-MM-DD'
      );
    }
    // if (this.route.snapshot.data.id) {
    // this.place = this.route.snapshot.data.id;
    if (this.place?.tag == 'Parking' && this.vehicleNumber != undefined) {
      this.subject =
        this.translateService.instant('vehicleNumberSubject') +
        ' ' +
        this.vehicleNumber;
    }
    // }
    // this.route.paramMap.subscribe((params) => {
    // this.bookingType = params.get('bookingType');
    // console.log(this.bookingType, this.place);
    // if (this.bookingType == 'qrCode') {
    //   this.subtitle = 'availableTimeBookingTitle';
    // } else if (this.bookingType == 'scheduleBooking') {
    //   this.subtitle = 'scheduleBookingSubtitle';
    // }
    // });
    // this.backService.showAreYouSureModal = true;
    //this.apiService.checkOrgTeamsConnector().subscribe(state =>this.canBookOnline = state)
    // this.dateTimeFormatService.selectedDateTimeFormat$.subscribe((format) => {
    //   this.locale = format;
    // });
  }

  private getAvailableTimesForSliders(start, end) {
    this.apiService
      .getPlaceScheduleById(this.place.emailAddress, start, end)
      .pipe(
        map((r) => {
          this.periods = [];
          r.forEach((time, index) => {
            let startTime;
            let endTime;
            if (index == 0) {
              startTime = moment(time.start)
                .add(this.roundUpMinutes(time.start), 'minutes')
                .locale(this.locale())
                .format(DATETIMEFORMART);
            } else {
              startTime = moment(time.start)
                .subtract(this.roundDownMinutes(time.start), 'minutes')
                .add(5, 'minutes')
                .locale(this.locale())
                .format(DATETIMEFORMART);
            }

            if (index != r.length - 1) {
              endTime = moment(time.end)
                .add(this.roundUpMinutes(time.start), 'minutes')
                .locale(this.locale())
                .format(DATETIMEFORMART);
            } else {
              endTime = moment(time.end)
                .locale(this.locale())
                .format(DATETIMEFORMART);
            }
            var startTimeMinutes = this.timeToMinute(startTime.toString());
            var endTimeMinutes = this.timeToMinute(endTime.toString());
            if (endTimeMinutes - startTimeMinutes >= 30) {
              this.periods.push({
                startTime: startTime,
                selectedStartTime: startTime,
                endTime: endTime,
                selectedEndTime: endTime,

                startTimeMinutes: startTimeMinutes,
                endTimeMinutes: endTimeMinutes,
                selectedTimesRange: {
                  lower: startTimeMinutes,
                  upper: endTimeMinutes,
                },
                isAdjusted: false,
              });
            }
          });
          this.slidersLoading = false;
        }),
        catchError((err) => {
          throw new Error(err);
        })
      )
      .subscribe();
  }

  public dateChange(event) {
    this.slidersLoading = true;
    this.isTimeSelected = false;
    this.newDate = moment(event.target.value).format('YYYY-MM-DD');
    let end = moment(event.target.value)
      .set({ hours: 23, minutes: 59, seconds: 0 })
      .toISOString();
    let start =
      this.newDate != moment().format('YYYY-MM-DD')
        ? moment(event.target.value)
            .set({ hours: 0, minutes: 0, seconds: 1 })
            .utc()
            .toISOString()
        : moment().set('milliseconds', 0).utc().toISOString();
    this.searchRequestDate = this.newDate;
    this.getAvailableTimesForSliders(start, end);

    this.presentAttendeeNotificationToast();

    this.attendees = [];
  }

  private roundUpMinutes(startTime: string) {
    let roundedToNextFiveMinute = 0;
    roundedToNextFiveMinute =
      moment(startTime).minute() % 5 == 0
        ? 0
        : 5 - (moment(startTime).minute() % 5);
    return roundedToNextFiveMinute;
  }

  private roundDownMinutes(endTime: string) {
    return moment(endTime).minute() % 5;
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  minuteToTime(minutes: number): string {
    const startHours = Math.floor(minutes / 60);
    const startMinutes = minutes % 60;
    return (
      this.formatDigits(startHours) + ':' + this.formatDigits(startMinutes)
    );
  }

  timeToMinute(date: string): number {
    let TempHour = date.split('T');
    let Time = TempHour[1].split(':');
    return Number(Time[0]) * 60 + Number(Time[1]);
  }

  updateTime(index: number, event) {
    this.isTimeSelected = false;
    this.checkRangeSelectedTime(index);
    let period = this.periods[index];
    period.selectedStartTime = moment(this.newDate)
      .set('hour', Math.floor(event.detail.value.lower / 60))
      .set('minute', event.detail.value.lower % 60)
      .format(DATETIMEFORMART);
    period.selectedEndTime = moment(this.newDate)
      .set('hour', Math.floor(event.detail.value.upper / 60))
      .set('minute', event.detail.value.upper % 60)
      .format(DATETIMEFORMART);

    this.presentAttendeeNotificationToast();
    this.attendees = [];
    this.periods[index].isAdjusted = true;
  }

  checkRangeSelectedTime(index: number) {
    let period = this.periods[index];
    if (period.selectedTimesRange.lower === period.selectedTimesRange.upper) {
      let range = {
        lower: period.selectedTimesRange.lower,
        upper: period.selectedTimesRange.upper,
      };
      if (range.upper === period.endTimeMinutes) range.lower -= 5;
      else range.upper += 5;

      period.selectedTimesRange = range;
    }
  }

  async updateRange(index: number) {
    this.isTimeSelected = false;
    let period = this.periods[index];
    //Start Time
    let TempStartHour = period.selectedStartTime.split('T');
    let StartHour = TempStartHour[1].split(':');
    let lowerValue = Number(StartHour[0]) * 60 + Number(StartHour[1]);
    //End Time
    let TempEndHour = period.selectedEndTime.split('T');
    let EndHour = TempEndHour[1].split(':');
    let upperValue = Number(EndHour[0]) * 60 + Number(EndHour[1]);

    period.selectedTimesRange = { lower: lowerValue, upper: upperValue };

    this.presentAttendeeNotificationToast();
    this.attendees = [];
  }

  formatDigits(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

  addMinutes(minutes: number, date: string): string {
    return moment(date).add(minutes, 'm').format(DATETIMEFORMART);
  }
  selectEventTime(slider: number) {
    this.showError = false;
    this.errorMessage = '';
    this.sliderNumber = slider;
    if (
      this.periods[slider].selectedStartTime ==
      this.periods[slider].selectedEndTime
    ) {
      this.errorMessage = this.translateService.instant('sameTimeSliderError');
      this.showError = true;
      return;
    }
    this.isTimeSelected = true;

    this.searchRequest = {
      startTimeUTC: moment(this.periods[slider].selectedStartTime)
        .utc()
        .format(DATETIMEFORMART),
      endTimeUTC: moment(this.periods[slider].selectedEndTime)
        .utc()
        .format(DATETIMEFORMART),
    };
    this.periods[slider].isActive = true;
    for (let index = 0; index < this.periods.length; index++) {
      if (index != slider) {
        this.periods[index].isActive = false;
      }
    }
  }

  doBookNewEvent() {
    this.bookingLoading = true;
    let period = this.periods[this.sliderNumber];
    const eventRequest: EventRequest = this.mapEventRequest(period);

    this.checkAvailabilityAndCreateEvent(eventRequest)
      .pipe(
        catchError(() => {
          this.bookingLoading = false;
          throw this.createEventGeneralErrorHandler();
        })
      )
      .subscribe();
  }

  private checkAvailabilityAndCreateEvent(eventRequest: EventRequest) {
    // this.searchService.checkAvailabillityRequest$.next(true);

    return this.checkAvailability(eventRequest).pipe(
      switchMap((res) => {
        if (res) {
          return this.apiService.createCalendarEvent(eventRequest).pipe(
            map(() => {
              this.placesStore.setPlacePending(this.place.emailAddress);
              this.presentNotification(
                eventRequest.startTime,
                eventRequest.endTime
              );
            }),
            catchError(() => {
              this.slidersLoading = false;
              this.createEventGeneralErrorHandler();
              console.log('error');
              return of();
            }),
            finalize(() => {
              // this.searchService.checkAvailabillityRequest$.next(false);
              this.slidersLoading = false;
            })
          );
        } else {
          console.log('not Available');
          // this.searchService.isBookable$.next(false);
          this.slidersLoading = false;
          return of(false);
        }
      })
    );
  }
  async presentNotification(start: string, end: string) {
    let day = moment(start).locale(this.locale()).format('L');
    if (day == moment().locale(this.locale()).format('L')) {
      day = '';
    } else {
      day += ' ';
    }

    let message = '';
    if (this.bookingType == 'qrCode') {
      message =
        'HXA ' +
        this.translateService.instant('newBooking') +
        ' ' +
        day +
        this.translateService.instant('eventCreatedToastOne') +
        ' ' +
        moment(start).locale(this.locale()).format('HH:mm') +
        ' ' +
        this.translateService.instant('eventCreatedToastTwo') +
        ' ' +
        moment(end).locale(this.locale()).format('HH:mm') +
        ' ' +
        this.translateService.instant('eventCreatedToastThree');
    } else {
      console.log(this.subtitle);
      message =
        'HXA ' +
        this.translateService.instant(this.subtitle) +
        ' ' +
        day +
        this.translateService.instant('eventCreatedToastOne') +
        ' ' +
        moment(start).locale(this.locale()).format('HH:mm') +
        ' ' +
        this.translateService.instant('eventCreatedToastTwo') +
        ' ' +
        moment(end).locale(this.locale()).format('HH:mm') +
        ' ' +
        this.translateService.instant('eventCreatedToastThree');
    }

    this.router.navigate(['tabs/bookings'], { replaceUrl: true });
    if (
      (this.platform.is('android') || this.platform.is('ios')) &&
      !this.platform.is('mobileweb')
    ) {
      var isNotificationPermissionExist =
        await this.localNotificationService.presentLocalNotification(
          message,
          'Booking status'
        );
      if (!isNotificationPermissionExist) {
        this.openToastIfSuccess(message);
      }
    } else {
      this.openToastIfSuccess(message);
    }
    this.dismissModal();
    this.bookingLoading = false;
    // this.searchService.resetDefaultSearchState();
    this.router.navigate(['tabs/bookings'], { replaceUrl: true });
  }

  async openToastIfSuccess(message) {
    await this.toastService.openActionToastAsync({
      message: message,
      duration: 5000,
      position: 'top',
      swipeGesture: 'vertical',
      positionAnchor: 'bookings-page-header-anchor',
      // onDismissActions: [
      //   async () => this.searchService.resetDefaultSearchState(),
      //   async () =>
      //     this.router.navigate(['tabs/bookings'], { replaceUrl: true }),
      // ],
    });
  }

  private checkAvailability(eventRequest: EventRequest) {
    return this.apiService
      .checkPlaceAvailability(
        eventRequest.placeEmailAddress,
        eventRequest.startTime,
        eventRequest.endTime,
        this.place.isOnPrem
      )
      .pipe(
        map((res) => {
          // this.searchService.isBookable$.next(res);
          return res;
        })
      );
  }

  private mapEventRequest(period: BookingPeriod): EventRequest {
    let eventRequest: EventRequest = {
      placeEmailAddress: this.place.emailAddress,
      subject:
        this.subject == undefined
          ? 'HXA ' + this.translateService.instant('quickBooking')
          : this.subject,
      startTime: moment(period.selectedStartTime).utc().format(),
      endTime: moment(period.selectedEndTime).utc().format(),
      reminderMinutesBeforeStart: this.reminderMinutesBeforeStart,
      showAs: this.showAs,
      bookingType: BookingTypeValue.SliderBooking,
      isOnPrem: this.place.isOnPrem,
      isOnlineMeeting: this.isOnlineMeeting,
      timeZoneInfo: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    if (this.bookingType == 'scheduleBooking') {
      eventRequest.attendees = this.attendees;
      eventRequest.subject =
        this.subject == undefined || this.subject == ''
          ? 'HXA ' + this.translateService.instant('scheduledBooking')
          : this.subject;
    }
    return eventRequest;
  }
  async openAttendeesModal() {
    const modal = await this.modalController.create({
      component: AddAttendeeComponent,
      initialBreakpoint: 0.95,
      breakpoints: [0, 0.95],
      canDismiss: async (data, role) => role != 'gesture',
      componentProps: {
        initialAttendees: this.attendees,
        bookingType: 'book',
        startTime: this.searchRequest.startTimeUTC,
        endTime: this.searchRequest.endTimeUTC,
      },
    });
    modal.onDidDismiss().then((result) => {
      if (result.data) {
        this.attendees = result.data;
      }
    });
    modal.present();
  }

  navigate(route: string) {
    this.router.navigate([route], { replaceUrl: true });
  }

  setDefaultReminderMinutes(initialValue: any, listValue: any): boolean {
    return initialValue && listValue
      ? initialValue == listValue
      : initialValue == listValue;
  }

  changeReminder(event) {
    this.reminderMinutesBeforeStart = event.target.value;
  }
  changeStatus(event) {
    this.showAs = event.target.value;
  }
  setFocus(field) {
    field.setFocus();
  }
  initAutoGrow() {
    this.isAutoGrow = true;
  }
  async createEventGeneralErrorHandler() {
    let previousUrl =
      this.backService.navigationUrls[
        this.backService.navigationUrls.length - 2
      ];
    await this.toastService.openActionToastAsync({
      message: 'createEventGeneralErrorToast',
      duration: 5000,
      color: 'danger',
      onDismissActions: [
        async () => this.router.navigate([previousUrl], { replaceUrl: true }),
      ],
    });
  }

  async presentAttendeeNotificationToast() {
    if (this.attendees.length > 0) {
      this.toastService.openActionToastAsync({
        message: 'removedAttendeesNotification',
        duration: 7000,
        cssClass: 'warning-toast',
        icon: 'warning-outline',
      });
    }
  }

  getMinuteValues(selectedTime: string): string {
    if (!selectedTime) return '0,5,10,15,20,25,30,35,40,45,50,55';

    const hour = new Date(selectedTime).getHours();
    return hour === 23
      ? '0,5,10,15,20,25,30,35,40,45,50,55,59'
      : '0,5,10,15,20,25,30,35,40,45,50,55';
  }
  clearSubject() {
    this.subject = '';
  }
}
